// @flow

import * as R from 'ramda';

import { HttpService } from '~/services';
import { renameKeys } from '~/helpers';

export const resolvers = {
  Query: {
    scoreTableList: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      props: ScoreTableInputProps,
      { cache }: ApolloCache,
    ): Promise<?(ScoreTableListItem[])> => {
      const locale = R.propOr('en', 'locale', props);

      if (!locale) return [];

      // Get score table
      const {
        data: { ScoreDetails },
      } = await HttpService.client.get('/Information/ScoreTable');

      let scoreTableList: ScoreTableListItem[] =
        locale === 'en'
          ? R.map(
              R.pipe(
                renameKeys({
                  DisplayNum: 'id',
                  Score: 'amount',
                  ScorePercentage: 'reward',
                  DirectReferral: 'referral',
                }),
                R.omit(['DirectReferral2', 'ScorePercentage2']),
                R.assoc('__typename', 'ScoreTableListItem'),
              ),
              ScoreDetails,
            )
          : R.map(
              R.pipe(
                item => ({
                  ...item,
                  ScorePercentage2: parseFloat(item.ScorePercentage2),
                }),
                renameKeys({
                  DisplayNum: 'id',
                  Score: 'amount',
                  ScorePercentage2: 'reward',
                  DirectReferral2: 'referral',
                }),
                R.omit(['DirectReferral', 'ScorePercentage']),
                R.assoc('__typename', 'ScoreTableListItem'),
              ),
              ScoreDetails,
            );

      cache.writeData({
        data: { scoreTableList },
      });

      return scoreTableList;
    },
  },
};
